import one from './one.js'
import any from './any.js'
import many from './many.js'
import map from './map.js'

export const relations = {
  one, any, many, map
};

export default relations;
